import React, { useEffect } from 'react';
import styled from 'styled-components';

import { AppState } from '../../store';
import { UserInterface } from '../../store/base/types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { Card, DynamicForm, Spin, CardActionButton } from '../elements';
import { updateUserProfile, fetchUsers } from '../../store/base/functions';

type EditUserComponentProps = {
    className?: string,
    match: any,
    user?: UserInterface,
    users?: UserInterface[],
    onUserUpdate: Function,
    onFetchUsers: Function,
    isLoading: boolean
}

const EditUserComponent = (props: EditUserComponentProps) => {
    const handleSubmit = (data : UserInterface) => {
        delete data['phone'];
        data = Object.assign({}, data, {
            avatar_id : null,
            signature_id: null
        })
        props.onUserUpdate(data, props.user ? props.user.id : null);
    }
    useEffect(() => {
       props.onFetchUsers();
       return () => {};
    }, [])
    const fields = [
        {
            id: "phone",
            htmltype : "phone",
            label : "تلفن همراه",
            defaultValue: props.user ? props.user.phone : '',
            disabled: true
        },
        {
            id : "first_name",
            htmltype : "text",
            label : "نام",
            defaultValue: props.user ? props.user.first_name: ''
        },
        {
            id : "last_name",
            htmltype: "text",
            label : "نام خانوادگی",
            defaultValue: props.user ? props.user.last_name : ''
        },
        {
            id: "email",
            htmltype: "email",
            label : "ایمیل",
            defaultValue: props.user ? props.user.email : ''
        }
    ]
    return (
      <div className={props.className} style={{marginLeft:20}}>
          {props.user &&
            <Card
              title={"ویرایش اطلاعات کاربر"}
              headerMeta={<>
               <CardActionButton title="بازگشت" to={`/users`} hasBorderRight={true}/>
             </>}
            >
                <Spin active={props.isLoading}>
                    <div style={{padding:'20px'}}>
                        <DynamicForm fields={fields} onSubmit={handleSubmit}/>
                    </div>
                </Spin>
            </Card>
          }
        </div>

    )
}

const EditUser = styled(EditUserComponent)`

`

const mapStateToProps = (state: AppState,ownProps: any) => {
   let currentUser:UserInterface | undefined = state.base.users.find((element:UserInterface) => element.id == ownProps.match.params.id);
   return ({
      user: currentUser,
      users: state.base.users,
      isLoading: state.base.isLoading
   })
}



const mapDispatchToProps = (dispatch:any) => {
    return {
        onUserUpdate: (data :UserInterface, id:number) => dispatch(updateUserProfile(data, id)),
        onFetchUsers: () => dispatch(fetchUsers())
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditUser));